import {
  DropDownIcon,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useWinnersCtx } from "@/contexts/winners";
import { useTranslation } from "@/i18n/client";
import WINNERS from "@/i18n/locales/en/winners.json";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import useLocalRouter from "@/hooks/use-router";

const DropDown = () => {
  const { year, setYear, lang } = useWinnersCtx();
  const { t } = useTranslation(lang, "winners");
  const router = useLocalRouter();

  const years = t("years", {
    returnObjects: true,
  }) as (typeof WINNERS)["years"];

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="min-w-[120px] rounded-full bg-foreground px-4 py-2 text-sm text-secondary sm:py-3">
        <div className="flex items-center justify-between gap-2 text-xs sm:text-sm ltr:font-opensans">
          {year.title}
          <DropDownIcon />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-foreground text-secondary">
        {years?.map((year) => (
          <DropdownMenuItem
            key={year.title}
            className="cursor-pointer ltr:font-opensans"
            onClick={() => {
              setYear({ title: year.title, value: year.value });
              router.push(
                {
                  search: {
                    year: year.value,
                  },
                },
                {
                  scroll: false,
                },
              );
            }}
          >
            {year.title}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export function YearFilter() {
  const { lang } = useWinnersCtx();
  const { t } = useTranslation(lang, "winners");
  return (
    <>
      <div className="hidden items-center gap-4 sm:flex">
        <p className="min-w-[50px] text-sm text-secondary/40 sm:min-w-[0px] ltr:font-opensans rtl:min-w-[65px] rtl:sm:min-w-[0px]">
          {t("Year")}:{" "}
        </p>
        <DropDown />
      </div>
      <div className="w-full sm:hidden">
        <TabsComponent />
      </div>
    </>
  );
}

export function TabsComponent() {
  const { year, setYear, lang } = useWinnersCtx();
  const { t } = useTranslation(lang, "winners");

  const years = t("years", {
    returnObjects: true,
  }) as (typeof WINNERS)["years"];

  return (
    <div className="flex gap-2 overflow-x-auto">
      {years.map((y) => (
        <button
          onClick={() => setYear({ title: y.title, value: y.value })}
          key={y.title}
          className={buttonVariants({
            className: cn(
              "!h-12 !rounded-[1000px] bg-secondary/10 !py-0 px-6 text-sm text-secondary transition-all duration-150 ease-in sm:text-base",
              year.title === y.title
                ? "bg-secondary text-background"
                : "hover:bg-secondary/20",
            ),
            variant: "ghost",
          })}
        >
          {y.title}
        </button>
      ))}
    </div>
  );
}
